// extracted by mini-css-extract-plugin
export default {"footer":"AppModalFooter_footer__NMo9j"};